import { c as D } from "./condition-attribute-with-id-DpTOoDfo.js";
import { r as S } from "./random-id-aENvrLj2.js";
import { S as I } from "./Base-ChuuONkW.js";
import { i as K, a as q } from "./platform-Dk-mE3cE.js";
const $ = new class {
  constructor(t = {}) {
    this.warmUpDelay = 1e3, this.coolDownDelay = 1e3, this.isWarm = !1, this.timeout = 0, Object.assign(this, t);
  }
  async openTimer(t) {
    if (this.cancelCooldownTimer(), !this.component || t !== this.component) return this.component && (this.close(this.component), this.cancelCooldownTimer()), this.component = t, !this.isWarm && (this.promise = new Promise((e) => {
      this.resolve = e, this.timeout = window.setTimeout(() => {
        this.resolve && (this.resolve(!1), this.isWarm = !0);
      }, this.warmUpDelay);
    }), this.promise);
    if (this.promise) return this.promise;
    throw new Error("Inconsistent state");
  }
  close(t) {
    this.component && this.component === t && (this.resetCooldownTimer(), this.timeout > 0 && (clearTimeout(this.timeout), this.timeout = 0), this.resolve && (this.resolve(!0), delete this.resolve), delete this.promise, delete this.component);
  }
  resetCooldownTimer() {
    this.isWarm && (this.cooldownTimeout && window.clearTimeout(this.cooldownTimeout), this.cooldownTimeout = window.setTimeout(() => {
      this.isWarm = !1, delete this.cooldownTimeout;
    }, this.coolDownDelay));
  }
  cancelCooldownTimer() {
    this.cooldownTimeout && window.clearTimeout(this.cooldownTimeout), delete this.cooldownTimeout;
  }
}(), u = () => {
}, M = (t, e, s) => {
  const o = new AbortController(), i = /* @__PURE__ */ new Map(), b = () => {
    o.abort(), s();
  };
  let h, n;
  const w = requestAnimationFrame(() => {
    h = requestAnimationFrame(() => {
      n = requestAnimationFrame(() => {
        b();
      });
    });
  }), C = (r) => {
    r.target === t && (i.set(r.propertyName, i.get(r.propertyName) - 1), i.get(r.propertyName) || i.delete(r.propertyName), i.size === 0 && b());
  };
  t.addEventListener("transitionrun", (r) => {
    r.target === t && (i.has(r.propertyName) || i.set(r.propertyName, 0), i.set(r.propertyName, i.get(r.propertyName) + 1), cancelAnimationFrame(w), cancelAnimationFrame(h), cancelAnimationFrame(n));
  }, { signal: o.signal }), t.addEventListener("transitionend", C, { signal: o.signal }), t.addEventListener("transitioncancel", C, { signal: o.signal }), e();
};
function U() {
  return new Promise((t) => requestAnimationFrame(() => t()));
}
class L extends I {
  constructor() {
    super(...arguments), this.dispose = u, this.offset = 0, this.willPreventClose = !1;
  }
  async applyFocus(e, s) {
  }
  get delayed() {
    return !1;
  }
  set delayed(e) {
  }
  get disabled() {
    return !1;
  }
  set disabled(e) {
  }
  get elementResolver() {
    return this._elementResolver;
  }
  set elementResolver(e) {
    this._elementResolver = e;
  }
  async ensureOnDOM(e) {
  }
  async makeTransition(e) {
    return null;
  }
  async manageDelay(e) {
  }
  async manageDialogOpen() {
  }
  async managePopoverOpen() {
  }
  managePosition() {
  }
  get open() {
    return !1;
  }
  set open(e) {
  }
  get placementController() {
    return this._placementController;
  }
  set placementController(e) {
    this._placementController = e;
  }
  requestSlottable() {
  }
  returnFocus() {
  }
  get state() {
    return "closed";
  }
  set state(e) {
  }
  manuallyKeepOpen() {
  }
  static update() {
    const e = new CustomEvent("sp-update-overlays", { bubbles: !0, composed: !0, cancelable: !0 });
    document.dispatchEvent(e);
  }
  static async open(e, s, o, i) {
    await import("./sp-overlay-D-aFOzDh.js");
    const b = arguments.length === 2, h = o || e, n = new this();
    let w = !1;
    n.dispose = () => {
      n.addEventListener("sp-closed", () => {
        w || (C(), w = !0), requestAnimationFrame(() => {
          n.remove();
        });
      }), n.open = !1, n.dispose = u;
    };
    const C = ((a, g, { position: d, prepareCallback: O } = { position: "beforeend" }) => {
      let { length: y } = a;
      if (y === 0) return () => a;
      let N = 1, v = 0;
      (d === "afterbegin" || d === "afterend") && (N = -1, v = y - 1);
      const E = new Array(y), R = new Array(y), x = document.createComment("placeholder for reparented element");
      do {
        const l = a[v];
        O && (R[v] = O(l)), E[v] = x.cloneNode();
        const p = l.parentElement || l.getRootNode();
        p && p !== l && p.replaceChild(E[v], l), g.insertAdjacentElement(d, l), v += N;
      } while (--y > 0);
      return function() {
        return function(l, p, k = []) {
          for (let c = 0; c < p.length; ++c) {
            const F = p[c], f = l[c], P = f.parentElement || f.getRootNode();
            k[c] && k[c](F), P && P !== f && P.replaceChild(F, f), delete l[c];
          }
          return p;
        }(E, a, R);
      };
    })([h], n, { position: "beforeend", prepareCallback: (a) => {
      const g = a.slot;
      return a.removeAttribute("slot"), () => {
        a.slot = g;
      };
    } });
    if (!b && h && i) {
      const a = e, g = s, d = i;
      return L.applyOptions(n, { ...d, delayed: d.delayed || h.hasAttribute("delayed"), trigger: d.virtualTrigger || a, type: g === "modal" ? "modal" : g === "hover" ? "hint" : "auto" }), a.insertAdjacentElement("afterend", n), await n.updateComplete, n.open = !0, n.dispose;
    }
    const r = s;
    return n.append(h), L.applyOptions(n, { ...r, delayed: r.delayed || h.hasAttribute("delayed") }), n.updateComplete.then(() => {
      n.open = !0;
    }), n;
  }
  static applyOptions(e, s) {
    var o, i;
    e.delayed = !!s.delayed, e.receivesFocus = (o = s.receivesFocus) != null ? o : "auto", e.triggerElement = s.trigger || null, e.type = s.type || "modal", e.offset = (i = s.offset) != null ? i : 0, e.placement = s.placement, e.willPreventClose = !!s.notImmediatelyClosable;
  }
}
var m, T = ((m = T || {})[m.click = 0] = "click", m[m.hover = 1] = "hover", m[m.longpress = 2] = "longpress", m);
class A {
  constructor(e, { overlay: s, isPersistent: o, handleOverlayReady: i }) {
    this.target = e, this.isLazilyOpen = !1, this.isPersistent = !1, this.isPersistent = !!o, this.handleOverlayReady = i, this.isPersistent && this.init(), this.overlay = s;
  }
  get activelyOpening() {
    return !1;
  }
  get open() {
    var e, s;
    return (s = (e = this.overlay) == null ? void 0 : e.open) != null ? s : this.isLazilyOpen;
  }
  set open(e) {
    if (e !== this.open) {
      if (this.isLazilyOpen = e, this.overlay) return void (this.overlay.open = e);
      e && (customElements.whenDefined("sp-overlay").then(async () => {
        const { Overlay: s } = await import("./Overlay-DvOyF6kR.js");
        this.overlay = new s(), this.overlay.open = !0;
      }), import("./sp-overlay-D-aFOzDh.js"));
    }
  }
  get overlay() {
    return this._overlay;
  }
  set overlay(e) {
    var s;
    e && this.overlay !== e && (this.overlay && this.overlay.removeController(this), this._overlay = e, this.overlay.addController(this), this.initOverlay(), this.prepareDescription(this.target), (s = this.handleOverlayReady) == null || s.call(this, this.overlay));
  }
  prepareDescription(e) {
  }
  releaseDescription() {
  }
  shouldCompleteOpen() {
  }
  init() {
  }
  initOverlay() {
  }
  abort() {
    var e;
    this.releaseDescription(), (e = this.abortController) == null || e.abort();
  }
  hostConnected() {
    this.init();
  }
  hostDisconnected() {
    this.isPersistent || this.abort();
  }
}
const W = { touch: "Double tap and long press for additional options", keyboard: "Press Space or Alt+Down Arrow for additional options", mouse: "Click and hold for additional options" }, B = { click: class extends A {
  constructor() {
    super(...arguments), this.type = T.click, this.preventNextToggle = !1;
  }
  handleClick() {
    this.preventNextToggle || (this.open = !this.open), this.preventNextToggle = !1;
  }
  handlePointerdown() {
    this.preventNextToggle = this.open;
  }
  init() {
    var t;
    (t = this.abortController) == null || t.abort(), this.abortController = new AbortController();
    const { signal: e } = this.abortController;
    this.target.addEventListener("click", () => this.handleClick(), { signal: e }), this.target.addEventListener("pointerdown", () => this.handlePointerdown(), { signal: e });
  }
}, longpress: class extends A {
  constructor() {
    super(...arguments), this.type = T.longpress, this.longpressState = null, this.releaseDescription = u, this.handlePointerup = () => {
      var t;
      clearTimeout(this.timeout), this.target && (this.longpressState = ((t = this.overlay) == null ? void 0 : t.state) === "opening" ? "pressed" : null, document.removeEventListener("pointerup", this.handlePointerup), document.removeEventListener("pointercancel", this.handlePointerup));
    };
  }
  get activelyOpening() {
    return this.longpressState === "opening" || this.longpressState === "pressed";
  }
  handleLongpress() {
    this.open = !0, this.longpressState = this.longpressState === "potential" ? "opening" : "pressed";
  }
  handlePointerdown(t) {
    !this.target || t.button !== 0 || (this.longpressState = "potential", document.addEventListener("pointerup", this.handlePointerup), document.addEventListener("pointercancel", this.handlePointerup), "holdAffordance" in this.target) || (this.timeout = setTimeout(() => {
      this.target && this.target.dispatchEvent(new CustomEvent("longpress", { bubbles: !0, composed: !0, detail: { source: "pointer" } }));
    }, 300));
  }
  handleKeydown(t) {
    const { code: e, altKey: s } = t;
    s && e === "ArrowDown" && (t.stopPropagation(), t.stopImmediatePropagation());
  }
  handleKeyup(t) {
    const { code: e, altKey: s } = t;
    if (e === "Space" || s && e === "ArrowDown") {
      if (!this.target) return;
      t.stopPropagation(), this.target.dispatchEvent(new CustomEvent("longpress", { bubbles: !0, composed: !0, detail: { source: "keyboard" } })), setTimeout(() => {
        this.longpressState = null;
      });
    }
  }
  prepareDescription(t) {
    if (this.releaseDescription !== u || !this.overlay.elements.length) return;
    const e = document.createElement("div");
    e.id = `longpress-describedby-descriptor-${S()}`;
    const s = K() || q() ? "touch" : "keyboard";
    e.textContent = W[s], e.slot = "longpress-describedby-descriptor";
    const o = t.getRootNode();
    o === this.overlay.getRootNode() ? this.overlay.append(e) : (e.hidden = !("host" in o), t.insertAdjacentElement("afterend", e));
    const i = D(t, "aria-describedby", [e.id]);
    this.releaseDescription = () => {
      i(), e.remove(), this.releaseDescription = u;
    };
  }
  shouldCompleteOpen() {
    this.longpressState = this.longpressState === "pressed" ? null : this.longpressState;
  }
  init() {
    var t;
    (t = this.abortController) == null || t.abort(), this.abortController = new AbortController();
    const { signal: e } = this.abortController;
    this.target.addEventListener("longpress", () => this.handleLongpress(), { signal: e }), this.target.addEventListener("pointerdown", (s) => this.handlePointerdown(s), { signal: e }), this.prepareDescription(this.target), !this.target.holdAffordance && (this.target.addEventListener("keydown", (s) => this.handleKeydown(s), { signal: e }), this.target.addEventListener("keyup", (s) => this.handleKeyup(s), { signal: e }));
  }
}, hover: class extends A {
  constructor() {
    super(...arguments), this.type = T.hover, this.elementIds = [], this.focusedin = !1, this.pointerentered = !1;
  }
  handleTargetFocusin() {
    this.target.matches(":focus-visible") && (this.open = !0, this.focusedin = !0);
  }
  handleTargetFocusout() {
    this.focusedin = !1, !this.pointerentered && (this.open = !1);
  }
  handleTargetPointerenter() {
    var t;
    this.hoverTimeout && (clearTimeout(this.hoverTimeout), this.hoverTimeout = void 0), ((t = this.overlay) == null || !t.disabled) && (this.open = !0, this.pointerentered = !0);
  }
  handleTargetPointerleave() {
    this.doPointerleave();
  }
  handleHostPointerenter() {
    this.hoverTimeout && (clearTimeout(this.hoverTimeout), this.hoverTimeout = void 0);
  }
  handleHostPointerleave() {
    this.doPointerleave();
  }
  prepareDescription() {
    if (!this.overlay.elements.length) return;
    const t = this.target.getRootNode(), e = this.overlay.elements[0].getRootNode();
    t === this.overlay.getRootNode() ? this.prepareOverlayRelativeDescription() : t === e && this.prepareContentRelativeDescription();
  }
  prepareOverlayRelativeDescription() {
    const t = D(this.target, "aria-describedby", [this.overlay.id]);
    this.releaseDescription = () => {
      t(), this.releaseDescription = u;
    };
  }
  prepareContentRelativeDescription() {
    const t = [], e = this.overlay.elements.map((o) => (t.push(o.id), o.id || (o.id = `${this.overlay.tagName.toLowerCase()}-helper-${S()}`), o.id));
    this.elementIds = t;
    const s = D(this.target, "aria-describedby", e);
    this.releaseDescription = () => {
      s(), this.overlay.elements.map((o, i) => {
        o.id = this.elementIds[i];
      }), this.releaseDescription = u;
    };
  }
  doPointerleave() {
    this.pointerentered = !1;
    const t = this.target;
    this.focusedin && t.matches(":focus-visible") || (this.hoverTimeout = setTimeout(() => {
      this.open = !1;
    }, 300));
  }
  init() {
    var t;
    (t = this.abortController) == null || t.abort(), this.abortController = new AbortController();
    const { signal: e } = this.abortController;
    this.target.addEventListener("focusin", () => this.handleTargetFocusin(), { signal: e }), this.target.addEventListener("focusout", () => this.handleTargetFocusout(), { signal: e }), this.target.addEventListener("pointerenter", () => this.handleTargetPointerenter(), { signal: e }), this.target.addEventListener("pointerleave", () => this.handleTargetPointerleave(), { signal: e }), this.overlay && this.initOverlay();
  }
  initOverlay() {
    if (!this.abortController) return;
    const { signal: t } = this.abortController;
    this.overlay.addEventListener("pointerenter", () => this.handleHostPointerenter(), { signal: t }), this.overlay.addEventListener("pointerleave", () => this.handleHostPointerleave(), { signal: t });
  }
} };
export {
  L as A,
  T as I,
  W as L,
  M as g,
  U as n,
  $ as o,
  B as s
};
//# sourceMappingURL=strategies-BOoCrCJR.js.map
